import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a0f0f] to-[#2d1810] py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-orange-500 hover:text-orange-400 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </button>

        {/* Content */}
        <div className="divine-card p-8 md:p-12">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">
            Terms & Conditions
          </h1>
          <p className="text-gray-400 mb-8"><strong>Effective Date:</strong> December 4, 2025</p>

          <div className="space-y-6 text-gray-300 leading-relaxed">
            <p>
              By using ShraddhaAI, you agree to the following terms:
            </p>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">1. Nature of Service</h2>
              <p className="mb-3">ShraddhaAI is a <strong>spiritual AI-based application</strong> that provides:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Conversations inspired by Hindu scriptures</li>
                <li>Devotional content</li>
                <li>Guidance for personal reflection</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">2. Important Disclaimer</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                <li>The deities in the app are <strong>AI-generated characters</strong></li>
                <li>They are <strong>inspired by Hindu scriptures and texts</strong></li>
                <li>They do <strong>not represent real gods</strong></li>
                <li>They do <strong>not provide divine, religious, or guaranteed advice</strong></li>
              </ul>

              <p className="mb-2"><strong>All responses:</strong></p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Are generated by AI</li>
                <li>Based on training data from scriptures</li>
                <li>Should be treated as <strong>guidance, not absolute truth</strong></li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">3. User Responsibility</h2>
              <p className="mb-2">You agree:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Not to misuse the platform</li>
                <li>Not to rely solely on the app for critical life decisions</li>
                <li>To use the app respectfully</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">4. Subscription & Payments</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Subscriptions are billed monthly</li>
                <li>Payments are non-refundable (unless required by law)</li>
                <li>Coins and in-app purchases are non-transferable</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">5. Intellectual Property</h2>
              <p>
                All content, branding, and AI systems belong to ShraddhaAI.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">6. Limitation of Liability</h2>
              <p className="mb-2">We are not responsible for:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Decisions taken based on app content</li>
                <li>Emotional or personal outcomes</li>
                <li>Misinterpretation of AI responses</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">7. Termination</h2>
              <p>
                We may suspend accounts for misuse or violation of terms.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">8. Changes</h2>
              <p>
                We may update these terms at any time.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">9. Governing Law</h2>
              <p>
                These terms are governed by the laws of India.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">Contact Us</h2>
              <div className="mt-4 p-4 bg-orange-500/10 border border-orange-500/20 rounded-lg">
                <p>Email: <a href="mailto:work.shraddhaai@gmail.com" className="text-orange-500 hover:text-orange-400">work.shraddhaai@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;